'use strict';

import React from 'react';
import Navigator from './NavigatorComponent';
import Header from './HeaderComponent';
import Item from './ItemComponent';
import PorderStore from 'stores/PorderStore';
import PorderActions from 'actions/PorderActions';
import Loading from './LoadingComponent';

require('styles/Orders.scss');

let calculateStatus = (porder) => {
  if(!porder.is_pay){
    return 1
  }else if(porder.is_pay && !porder.is_team){
    return 2
  }else if(porder.is_team && !porder.is_finish){
    return 3
  }else if(porder.is_finish && !porder.is_comment){
    return 4
  }else if(porder.is_refund){
    return 5
  }
}

class OrdersComponent extends React.Component {
  constructor(props) {
    super(props);
    let status = this.props.params.id;
    if(status){
      PorderActions.setData({status:status});
    }
    let porderStore = PorderStore.getState();
    this.state = {
      needRefreshHeight: false,
      status: porderStore.status,
      porders: porderStore.porders,
      loading: porderStore.loading,
      hasMore: porderStore.hasMore,
      waitPayPorders: porderStore.waitPayPorders,
      waitPayPordersLoading: porderStore.waitPayPordersLoading,
      waitPayPordersHasMore: porderStore.waitPayPordersHasMore,
      waitGoPorders: porderStore.waitGoPorders,
      waitGoPordersLoading: porderStore.waitGoPordersLoading,
      waitGoPordersHasMore: porderStore.waitGoPordersHasMore,
      waitCommentPorders: porderStore.waitCommentPorders,
      waitCommentPordersLoading: porderStore.waitCommentPordersLoading,
      waitCommentPordersHasMore: porderStore.waitCommentPordersHasMore,
      waitTeamPorders: porderStore.waitTeamPorders,
      waitTeamPordersLoading: porderStore.waitTeamPordersLoading,
      waitTeamPordersHasMore: porderStore.waitTeamPordersHasMore,
      showNavigator: false
    }
    this.onChange = this.onChange.bind(this);
    this.onPordersScroll = this.onPordersScroll.bind(this);
    this.clickMenu = this.clickMenu.bind(this);
    this.loadMore = this.loadMore.bind(this)
  }
  componentDidMount() {
    PorderStore.listen(this.onChange);
    PorderActions.fetchPorders();
    window.addEventListener('scroll', this.onPordersScroll);
  }
  componentWillUnmount() {
    PorderActions.setData({
      status:0,
      offset:0,
      waitPayPordersOffset:0,
      waitGoPordersOffset:0,
      waitCommentPordersOffset:0,
      waitTeamPordersOffset:0
    })
    PorderStore.unlisten(this.onChange);
    window.removeEventListener('scroll', this.onPordersScroll);
  }
  onChange(state) {
    this.setState({
      status: state.status,
      porders: state.porders,
      loading: state.loading,
      hasMore: state.hasMore,
      waitPayPorders: state.waitPayPorders,
      waitPayPordersLoading: state.waitPayPordersLoading,
      waitPayPordersHasMore: state.waitPayPordersHasMore,
      waitGoPorders: state.waitGoPorders,
      waitGoPordersLoading: state.waitGoPordersLoading,
      waitGoPordersHasMore: state.waitGoPordersHasMore,
      waitCommentPorders: state.waitCommentPorders,
      waitCommentPordersLoading: state.waitCommentPordersLoading,
      waitCommentPordersHasMore: state.waitCommentPordersHasMore,
      waitTeamPorders: state.waitTeamPorders,
      waitTeamPordersLoading: state.waitTeamPordersLoading,
      waitTeamPordersHasMore: state.waitTeamPordersHasMore
    });
  }
  onPordersScroll(event) {
    if(this.state.fetchTimeout) {
      clearTimeout(this.state.fetchTimeout);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
    let scrollHeight = event.srcElement.body.scrollHeight;
    if(scrollTop + clientHeight === scrollHeight) {
      let status = this.state.status;
      PorderActions.setData({loading:true,status:status})
      this.setState({fetchTimeout: setTimeout(PorderActions.fetchPorders.bind(null), 1000)});
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else {
      this.setState({showNavigator:false});
    }
  }
  loadMore() {
    let status = this.state.status;
    PorderActions.setData({loading:true,status:status}) 
    PorderActions.fetchPorders()
  }
  componentDidUpdate(){
    if(this.state.needRefreshHeight){
      let status = this.state.status;
      let porderStore = PorderStore.getState();
      if(status == 0){
        window.scrollTo(0,porderStore.offset);
      }else if(status == 1){
        window.scrollTo(0,porderStore.waitPayPordersOffset);
      }else if(status == 2){
        window.scrollTo(0,porderStore.waitTeamPordersOffset);
      }else if(status == 3){
        window.scrollTo(0,porderStore.waitGoPordersOffset);
      }else if(status == 4){
        window.scrollTo(0,porderStore.waitCommentPordersOffset);
      }
      this.state.needRefreshHeight = false;
    }
  }
  clickMenu(status){
    let originStatus= this.state.status;
    if(status != originStatus){
      if(status == 0){
        if(!this.state.porders.length){
          PorderActions.setData({loading:true,status:status})
          PorderActions.fetchPorders();
        }
      }else if(status == 1){
        if(!this.state.waitPayPorders.length){
          PorderActions.setData({loading:true,status:status})
          PorderActions.fetchPorders();
        }
      }else if(status == 2){
        if(!this.state.waitTeamPorders.length){
          PorderActions.setData({loading:true,status:status})
          PorderActions.fetchPorders();
        }
      }else if(status == 3){
        if(!this.state.waitGoPorders.length){
          PorderActions.setData({loading:true,status:status})
          PorderActions.fetchPorders();
        }
      }else if(status == 4){
        if(!this.state.waitCommentPorders.length){
          PorderActions.setData({loading:true,status:status})
          PorderActions.fetchPorders();
        }
      }
      if(originStatus == 0){
        PorderActions.setData({offset:$(document).scrollTop()})
      }else if(originStatus == 1){
        PorderActions.setData({waitPayPordersOffset:$(document).scrollTop()})
      }else if(originStatus == 2){
        PorderActions.setData({waitTeamPordersOffset:$(document).scrollTop()})
      }else if(originStatus == 3){
        PorderActions.setData({waitGoPordersOffset:$(document).scrollTop()})
      }else if(originStatus == 4){
        PorderActions.setData({waitCommentPordersOffset:$(document).scrollTop()})
      }
      this.setState({status:status,needRefreshHeight:true});
    }
  }
  render() {
    let noMoreWord,navigator;
    if(this.state.porders.length === 0) {
      noMoreWord = ' ';
    }
    if(this.state.showNavigator){
      navigator = <Navigator action = 'top' number={2} />;
    }
    let list = [],orders = [],status = this.state.status;
    if(status == 0){
      orders = this.state.porders;
    }else if(status == 1){
      orders = this.state.waitPayPorders;
    }else if(status == 2){
      orders = this.state.waitTeamPorders;
    }else if(status == 3){
      orders = this.state.waitGoPorders;
    }else if(status == 4){
      orders = this.state.waitCommentPorders;
    }
    if(orders.length){
      if(status == 0){
        list = orders.map(porder => {
          porder.status = calculateStatus(porder)
          return (
            <Item 
              key={porder._id} 
              id={porder._id} 
              start={porder.start_date} 
              end={porder.end_date} 
              create_date={porder.create_date} 
              desc={porder.desc} 
              title={porder.title} 
              price={porder.charge} 
              status={porder.status} 
              type={2}/>
          )
        })
      }else{
        list = orders.map(porder => {
          return (
            <Item 
              key={porder._id} 
              id={porder._id} 
              start={porder.start_date} 
              end={porder.end_date} 
              create_date={porder.create_date} 
              desc={porder.desc} 
              title={porder.title} 
              price={porder.charge} 
              status={status} 
              type={2}/>
          )
        })
      }
    }else{
      list =  (
        <div className="empty fz-12">～暂无此类型订单～</div>
      )
    }
    return (
      <div className="orders-component is-active">
        <Header title="我的订单" />
        <div className="kinds">
          <div className="fives"><a href="javascript:void(0)" onClick={this.clickMenu.bind(this,0)} className={`kind ${this.state.status==0?'active':''}`}>全部</a></div>
          <div className="fives"><a href="javascript:void(0)" onClick={this.clickMenu.bind(this,1)} className={`kind ${this.state.status==1?'active':''}`}>待付款</a></div>
          <div className="fives"><a href="javascript:void(0)" onClick={this.clickMenu.bind(this,2)} className={`kind ${this.state.status==2?'active':''}`}>拼团中</a></div>
          <div className="fives"><a href="javascript:void(0)" onClick={this.clickMenu.bind(this,3)} className={`kind ${this.state.status==3?'active':''}`}>待出行</a></div>
          <div className="fives"><a href="javascript:void(0)" onClick={this.clickMenu.bind(this,4)} className={`kind ${this.state.status==4?'active':''}`}>待评价</a></div>
          <div className="clear"></div>
        </div>
        <div className="content">
          {list}
        </div>
        <Loading noMoreWord={noMoreWord} loading={this.state.loading} hasMore={this.state.hasMore} loadMore={this.loadMore} />
        {navigator}
        <Navigator action='left' />
      </div>
    );
  }
}

OrdersComponent.displayName = 'OrdersComponent';
export default OrdersComponent;




// WEBPACK FOOTER //
// ./src/components/OrdersComponent.js